import { SubjectGroupDto } from '../../../../../../interfaces/dtos/SubjectGroupDto';
import { SubjectGroup } from '../../../../../../interfaces/SubjectGroup';

export default function transformSubjectGroups(dtos: SubjectGroupDto[]): SubjectGroup[] {
  const subjectGroups: SubjectGroup[] = [];
  dtos?.forEach((dto) => {
    subjectGroups.push({
      displayOrder: dto.displayOrder,
      id: dto.id,
      description: dto.description,
    });
  });
  return subjectGroups;
}
